import React from 'react'
import { shallow } from 'enzyme'

import ReadOnlyEditor from '../../features/TextEditor/ReadOnlyEditor'
import Files from '../../features/TextEditor/Files'
import Editor from 'draft-js-plugins-editor'

describe('ReadOnlyEditor', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      md: 'some content',
      files: [
        {
          name: 'test.jpg',
          url: 'www.google.com'
        }
      ],
    },
      wrapper = shallow(<ReadOnlyEditor {...props} />)
    instance = wrapper.instance()
  })
  describe('#render', () => {
    it('should have editor with readOnly prop', () => {
      const editor = wrapper.find(Editor).at(0)
      expect(editor).toHaveLength(1)
      expect(editor.props().readOnly).toBeTruthy()
    })
    describe('when files props is present', () => {
      it('should have Files with published and hideClose set to true', () => {
        const files = wrapper.find(Files).at(0)
        expect(files).toHaveLength(1)
        expect(files.props().hideClose).toBeTruthy()
        expect(files.props().published).toBeTruthy()
      })
    })
    describe('when files props is empty', () => {
      it('should not have Files', () => {
        props.files = []
        wrapper = shallow(<ReadOnlyEditor {...props} />)
        instance = wrapper.instance()
        const files = wrapper.find(Files).at(0)
        expect(files).toHaveLength(0)
      })
    })
  })
})